module.exports = __webpack_public_path__ + "static/media/timetable.5cca8f5f.png";